import * as actions from '../actions';

var defaultState = null;

export default function webhook(state = defaultState, action) {
    switch (action.type) {

        case actions.WEBHOOK_GET_ONE:
            var newState = state;
            if (!action.error) {
                newState = action.payload.data;
            }
            return newState;

        default:
            return state;

    }
}
